import { EAppSupportType } from "./app-support-type";
import { EPropertyType } from "./property-type";
import { IPropertyTypeOptions } from "./property-type-options";

export enum EEnumType {
  string = 1,
  number = 2,
  boolean = 3,
  object = 4,
  array = 5
}

export interface IPropertyDefinition {
  name: string;
  type: EPropertyType[];
  options: string[];
  hasOptions: boolean;
  description: string;
  typeOptions: IPropertyTypeOptions[];
  isRequired: boolean;
  isTechnical: boolean;
  isAdvanced: boolean;
  isIgnoredOnCodeOutput: boolean;
  isIgnoredOnGeneratedApp: boolean;
  tagName: string;
  defaultStylingTypography?: string;
  defaultStylingPosition?: string;
  defaultStylingBorder?: string;
  defaultStylingShadow?: string;
  defaultStylingFill?: string;

  isOptionsProp?: boolean;
  isLanguageOptionsProp?: boolean;
  isGoogleMapsOptionsProp?: boolean;
  isTableOptionsProp?: boolean;
  isChatOptionsProp?: boolean;
  isTreeOptionsProp?: boolean;
  isChartOptionsProp?: boolean;
  isTimelineOptionsProp?: boolean;
  isCalendarOptionsProp?: boolean;
  isMenuOptionsProp?: boolean;
  isBreadcrumbOptionsProp?: boolean;
  isRadialChartOptionsProp?: boolean;
  isRadialChartLevelOptionsProp?: boolean;
  isMixedChartOptionsProp?: boolean;
  isMixedChartLineOptionsProp?: boolean;
  isMixedChartPointOptionsProp?: boolean;
  isMixedChartBarOptionsProp?: boolean;
  isKanbanBoardLaneOptionsProp?: boolean;
  isKanbanBoardCardOptionsProp?: boolean;
  isNodeTreeNodeOptionsProp?: boolean;
  isDirectoryOptionsProp?: boolean;
  /**
   * KOA-18129 — the Date element's list of specific days. It is edited like an options list but is its own family
   * on purpose: the days constrain the Date's value and are never its domain, so it must stay invisible to every
   * reader of `isOptionsProp` / a property named `options` that treats the list as "the value is picked from here".
   */
  isSpecificDatesProp?: boolean;
  isEditabilityProp?: boolean;
  isVisibleProp?: boolean;
  isSelectProp?: boolean;
  isVisibleInFieldPicker?: boolean;
  isValueProp?: boolean;
  defaultValue: string;
  optionsDependsOn?: string;
  optionsByDependency?: Record<string, string[]>;
  isSupportMultiLanguage?: boolean;
  appSupportType?: EAppSupportType;
  isDeprecated?: boolean;
  renderer?: number;
  inVisibleStyles?: string[];
  hideFixedValue?: boolean;
  enumType?: EEnumType;
  kuikaTypeName?: string;
  isDomainType?: boolean;
  domainTypeName?: string;
  isList?: boolean;
  /**
   * Renders the property editor as a tags-mode select: `options` act as suggestions,
   * free-text entries are allowed, and the value is stored as a comma-separated string.
   */
  isTagsInput?: boolean;
}
